/**
 * 简单版本 uuid 生成器
 */
 let inc = 0;
 export function uuid() {
   inc++;
   if (inc >= 0xfffffff0) inc = 0;
   return Date.now().toString(32) + inc.toString(32);
 }